/**
 * login duck
 * @author Paul Kleimeyer
 *
 * @fileOverview maintain login module state
 * @module one-identity-login/duck
 *
 */
import { fromJS } from 'immutable';

export const DEFAULT_ROUTE = '/dashboard';

export const LOGIN_CLEAR_STATUS = 'modules/one-identity-login/CLEAR_STATUS';
export const LOGIN_RESET_STATUS = 'modules/one-identity-login/RESET_STATUS';
export const LOGIN_SET_DESTINATION = 'modules/one-identity-login/SET_DESTINATION';
export const LOGIN_SET_LOCATION = 'modules/one-identity-login/SET_LOCATION';
export const LOGIN_SET_CONTEXT = 'modules/one-identity-login/SET_CONTEXT';
export const LOGIN_SET_USERID = 'modules/one-identity-login/SET_USERID';
export const LOGIN_SET_HAS_DEVICE_REMEMBERED = 'modules/one-identity-login/SET_HAS_DEVICE_REMEMBERED';

export function createInitialState() {
  return fromJS({
    status: null,
    destination: null,
    context: null,
    userId: null,
    hasDeviceRemembered: false,
  });
}

// eslint-disable-next-line default-param-last -- allow default param last for reducer
export function reducer(state = createInitialState(), action) {
  switch (action.type) {
    case LOGIN_SET_DESTINATION:
      return state.set('destination', action.destination);
    case LOGIN_SET_LOCATION:
      return window && window.location.pathname.includes('/login')
        ? state.set('location', `${window.location.pathname}${window.location.search}`)
        : state;
    case LOGIN_CLEAR_STATUS:
      return state.set('status', { statusCode: 0 });
    case LOGIN_RESET_STATUS:
      return state.set('status', null);
    case LOGIN_SET_CONTEXT:
      return state.set('context', action.context);
    case LOGIN_SET_USERID:
      return state.set('userId', action.userId);
    case LOGIN_SET_HAS_DEVICE_REMEMBERED:
      return state.set('hasDeviceRemembered', action.hasDeviceRemembered);
    default:
      return state;
  }
}
